module.exports = __webpack_public_path__ + "static/media/ionic.90aa8d48.png";